export default __webpack_public_path__ + "static/media/ilbocLogoWhite.36be3f2b.png";